<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="{{ 'applicant-tracker.setUpAutomaticEmail' | appTranslate }}" [back]="true"></app-header>

    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <app-recruiting-automated-email-settings-form
                    [automatedEmailSettings]="automatedEmailSettings"
                    #automatedEmailSettingsForm
                ></app-recruiting-automated-email-settings-form>
                <div class="flex justify-flex-end">
                    <ui-button type="ghost" (click)="onCancel()">{{ 'cancel' | appTranslate }}</ui-button>
                    <ui-button type="primary" (click)="onSave(automatedEmailSettingsForm)">{{
                        'save' | appTranslate
                    }}</ui-button>
                </div>
            </div>
        </div>
        <div class="sidebar">
            <app-customization-tokens></app-customization-tokens>
        </div>
    </div>
</div>
